// extracted by mini-css-extract-plugin
module.exports = {"breakOnSpaces":"ArticleDisplay_breakOnSpaces__1Gfcn","yourHighlightClass":"ArticleDisplay_yourHighlightClass__g_1Yx"};